/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import ContentSettingsAudienceMultiplier from './content-settings-audience-multiplier';
import DefaultAudienceMultiplier from './default-audience-multiplayer';

/**
 * @import { IAudienceMultiplier } from '.'
 * @import { ContentInfo } from '../content/info/content-info'
 */

export default class AudienceMultiplierResolver {
  constructor() {
    this.defaultAudienceMultiplier = new DefaultAudienceMultiplier();
  }

  /**
   * @param {ContentInfo} contentInfo
   * @returns {IAudienceMultiplier}
   */
  get(contentInfo) {
    const audienceProvider = contentInfo.communicatorSettings.get(
      'player.audience.provider'
    );
    switch (audienceProvider) {
      case 'kv':
        return new ContentSettingsAudienceMultiplier(contentInfo);
      default:
        return this.defaultAudienceMultiplier;
    }
  }
}
